import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Helmet from 'react-helmet';

export default () => (
	<StaticQuery
		query={graphql`
			query helmetQuery {
				site {
					siteMetadata {
						title
						author
						description
						
					}
				}
			}
		`}
		render={data => (
			<Helmet>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
				/>
				<meta name="description" content={data.site.siteMetadata.description} />
				
				<title>{data.site.siteMetadata.title}</title>
				<html lang="es-MX" />
				{/* Google / Search Engine Meta Tags */}
				<meta itemprop="name" content={data.site.siteMetadata.author} /> />
				<meta
					itemprop="description"
					content={data.site.siteMetadata.description}
				/>
				
				<meta name="robots" content="index,follow"></meta>
				<link rel="canonical" href="https://autohemoterapia.mx/" />
				{/* <!-- Open Graph / Facebook --> */}
				<meta property="og:type" content="website" />
            <meta property="og:url" content="https://autohemoterapia.mx/" />
            <meta property="og:title" content="Autohemoterapia en México | Hemovacuna®" />
            <meta property="og:description" content="¿Buscas la vacuna de la autohemoterapia? Nosotros tenemos la experencia y calidad de este método 100% seguro para tu salud." />
            <meta property="og:image" content="https://res.cloudinary.com/dpzoehc6i/image/upload/v1582235228/photo_2020-02-20_15-45-58_wb5bdm.jpg" />
            {/* <!-- Twitter --> */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content="https://autohemoterapia.mx/" />
            <meta property="twitter:title" content="Autohemoterapia en México | Hemovacuna®" />
            <meta property="twitter:description" content="¿Buscas la vacuna de la autohemoterapia? Nosotros tenemos la experencia y calidad de este método 100% seguro para tu salud." />
            <meta property="twitter:image" content="https://res.cloudinary.com/dpzoehc6i/image/upload/v1582235228/photo_2020-02-20_15-45-58_wb5bdm.jpg" />

			</Helmet>
		)}
	/>
);
